import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.css']
})
export class WelcomeComponent implements OnInit {

  errMsg: string;

  constructor(private route: ActivatedRoute,
  ) { }

  ngOnInit() {

    this.route.params.map(params => params['codeErr']).subscribe(codeErr => {
      if (codeErr == 1) {
        this.errMsg = "The HOOK_URL is missing, you must click on the links to this platform. The HOOK_URL is get when you click on the catalog link, this message is show because you migth be refresh the page so the data are deleted for security reason. ";
      }
      if (codeErr == 2) {
        this.errMsg = "Wrong login!";
      }
    })

  }

}



// WEBPACK FOOTER //
// ./src/app/components/welcome/welcome.component.ts